import { TranslationKeys } from '../english/policies.i18n';

export const keys: TranslationKeys = {
  policyPages: {
    activePolicies: {
      title: 'Bonjour {{0}},',
      subtitle:
        "Gérez et modifiez vos polices actives ici. Une nouvelle police peut prendre jusqu'à 48 heures pour apparaître. Pour toute question, visitez <0>notre Centre d'Aide</0>.",
      tabs: {
        activePolicies: 'Polices actives',
        notifications: 'Notifications',
      },
      empty: 'Aucune police active',
    },
    modifyPolicy: {
      title: 'Modification de police',
      subtitle: 'Choisissez une option ci-dessous, suivez les étapes, et on se charge du reste.',
    },
    documents: {
      title: 'Documents',
      subtitle: "Veuillez noter qu'il peut prendre jusqu'à 48 heures pour que les nouveaux documents apparaissent.",
      failedToDownload: 'Le téléchargement du document a échoué, essayez plus tard ou <0>contactez le support</0>.',
    },
  },
};

export default keys;
